// frontend/src/pages/MaquetteRedirect.jsx
// Page de redirection : partenia.net/maquette/<code>  →  maquette Partenia du club.
// La liste des maquettes est côté serveur (backend/server.py, MAQUETTES) :
// elle n'apparaît pas dans le code public du site.

import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const page = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  background: "#EDF1EA",
  color: "#13201A",
  fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
};
const card = {
  maxWidth: 440,
  width: "100%",
  background: "#FFFFFF",
  border: "1px solid #D7DFD4",
  borderRadius: 16,
  padding: 28,
  textAlign: "center",
};
const mark = {
  width: 40,
  height: 40,
  borderRadius: 10,
  background: "#13201A",
  color: "#E3EBE5",
  display: "inline-grid",
  placeItems: "center",
  fontWeight: 800,
  fontSize: 20,
  marginBottom: 14,
};
const button = {
  display: "inline-block",
  marginTop: 18,
  padding: "12px 22px",
  borderRadius: 999,
  background: "#13201A",
  color: "#EDF1EA",
  fontWeight: 600,
  textDecoration: "none",
};

export default function MaquetteRedirect() {
  const { club } = useParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    // Les maquettes ne doivent pas apparaître dans Google.
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    return () => robots.remove();
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND}/api/maquette/${encodeURIComponent((club || "").toLowerCase())}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => {
        if (cancelled) return;
        document.title = `Maquette Partenia · ${data.name}`;
        setState({ status: "found", name: data.name, url: data.url });
        window.location.replace(data.url);
      })
      .catch(() => {
        if (!cancelled) setState({ status: "missing" });
      });
    return () => {
      cancelled = true;
    };
  }, [club]);

  return (
    <main style={page}>
      <div style={card}>
        <span style={mark}>P</span>
        {state.status === "missing" ? (
          <>
            <h1 style={{ fontSize: 22, margin: "0 0 6px" }}>Maquette introuvable</h1>
            <p style={{ margin: 0, color: "#4B5B52" }}>
              Ce lien ne correspond à aucune maquette Partenia.
            </p>
            <Link to="/" style={button}>Découvrir Partenia</Link>
          </>
        ) : (
          <>
            <h1 style={{ fontSize: 22, margin: "0 0 6px" }}>Maquette Partenia</h1>
            {state.name && <p style={{ margin: 0, color: "#4B5B52" }}>{state.name}</p>}
            <p style={{ margin: "16px 0 0", fontSize: 14, color: "#69786F" }}>
              Ouverture de votre maquette…
            </p>
            {state.url && <a href={state.url} style={button}>Ouvrir la maquette</a>}
          </>
        )}
      </div>
    </main>
  );
}
